import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "config/oktaConfig";

const oktaAuth = new OktaAuth(oktaConfig.oidc);

// Safety: ensure no instance-level restoreOriginalUri remains
// (prevents the “two custom restoreOriginalUri” warning)
if (oktaAuth?.options?.restoreOriginalUri) {
  delete oktaAuth.options.restoreOriginalUri;
}

export default oktaAuth;
